module.exports = __webpack_public_path__ + "static/media/59.9d92686.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/59.wav
// module id = mLPH
// module chunks = 0